// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"167":"234e5faf","238":"43d8b2d6","239":"e39fb35b","389":"47b9b298","453":"03346f77","455":"3bef4cb2","977":"240addac"}[chunkId] + ".chunk.js";
};